<template>
  <core-modal
    @close="closeModal"
    :stateOpen="isOpen"
    containerStyle="width: 40%"
  >
    <div slot="header" class="p-3 text-uppercase">
      {{ $t('reservation.date-changed') }}
    </div>
    <div slot="body">
      {{ $t('reservation.date-update-question') }}
    </div>
    <div slot="footer">
      <button
        type="button"
        @click="updateDateRange"
        class="btn btn-primary rounded m-0"
      >
        {{ $t('general.update') }}
      </button>
    </div>
  </core-modal>
</template>

<script>

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('clearDateRange')
      this.$emit('closeModal')
    },
    updateDateRange () {
      this.$emit('updateDateRange')
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/DateChangeModal.vue